const PENDING_CHECKOUT_REFRESH_KEY = 'pendingUpsellCheckoutRefresh'

let checkoutRefreshRunner = null

export function registerCheckoutRefreshRunner(runner) {
  checkoutRefreshRunner = runner
}

export function unregisterCheckoutRefreshRunner() {
  checkoutRefreshRunner = null
}

export function savePendingCheckoutRefresh(payload) {
  if (!payload) {
    return
  }

  sessionStorage.setItem(
    PENDING_CHECKOUT_REFRESH_KEY,
    JSON.stringify(payload),
  )
}

export function runDeferredCheckoutRefresh() {
  const raw = sessionStorage.getItem(PENDING_CHECKOUT_REFRESH_KEY)

  if (!raw) {
    return false
  }

  sessionStorage.removeItem(PENDING_CHECKOUT_REFRESH_KEY)

  try {
    const payload = JSON.parse(raw)
    checkoutRefreshRunner?.(payload)
    return true
  } catch {
    return false
  }
}
